/** Calendar-date versus instant semantics for descriptor-driven inputs. */
const DATE_ONLY = /^\d{4}-\d{2}-\d{2}$/;

export function isDateOnly(value: unknown): value is string {
  return typeof value === 'string' && DATE_ONLY.test(value);
}

/** HTML date inputs preserve a business calendar day exactly, without Date parsing. */
export function normalizeDateInput(value: unknown): unknown {
  if (value === null || value === undefined || value === '') return value;
  if (isDateOnly(value)) return value;
  const date = value instanceof Date ? value : new Date(String(value));
  if (Number.isNaN(date.getTime())) return value;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}`;
}

/** Datetime-local values are instants rendered in the local input timezone. */
export function normalizeDateTimeInput(value: unknown): unknown {
  if (value === null || value === undefined || value === '') return value;
  const date = value instanceof Date ? value : new Date(String(value));
  if (Number.isNaN(date.getTime())) return value;
  return `${date.getFullYear()}-${String(date.getMonth() + 1).padStart(2, '0')}-${String(date.getDate()).padStart(2, '0')}T${String(date.getHours()).padStart(2, '0')}:${String(date.getMinutes()).padStart(2, '0')}`;
}

/**
 * Table filters share the form calendar/instant boundary. Date-only values
 * remain a calendar value in URLs and API query DTOs; datetime-local input is
 * converted to the exact instant selected in the browser.
 */
export function normalizeDateFilterInput(value: unknown, fieldType: 'date' | 'datetime'): string {
  const normalized = fieldType === 'date'
    ? normalizeDateInput(value)
    : normalizeDateTimeInput(value);
  return typeof normalized === 'string' ? normalized : '';
}

export function serializeDateFilterValue(value: string, fieldType: 'date' | 'datetime'): string {
  if (!value || fieldType === 'date') return value;
  const instant = new Date(value);
  return Number.isNaN(instant.getTime()) ? value : instant.toISOString();
}
